import { Helmet } from "react-helmet";
import FaqsBody from "../components/faqs/FaqsBody";
import SolutionsNtunaCTAWorld from "../components/solutions/SolutionsNtunaCTAWorld";

export default function Faqs() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/frequently-asked-questions"
        />
        <meta
          name="description"
          content="Find answers to common questions about NTUNA.COM's way of serving clients and our services including Website, systems and app development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
       
        <meta
          property="og:description"
          content="Find answers to common questions about NTUNA.COM's way of serving clients and our services including Website, systems and app development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta
          property="og:title"
          content="NTUNA.COM - Frequently Asked Questions"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM - Frequently Asked Questions"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM - Frequently Asked Questions"
        />
        <meta
          name="twitter:description"
          content="Find answers to common questions about NTUNA.COM's way of serving clients and our services including Website, systems and app development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>NTUNA.COM - Frequently Asked Questions</title>
      </Helmet>
      <FaqsBody />
      <SolutionsNtunaCTAWorld />
    </>
  );
}
